(self["webpackChunk"] = self["webpackChunk"] || []).push([[3423],{

/***/ 48848:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(30741);module.exports = "../../app/cells/components/lesson_player/faq/show.erb";

/***/ }),

/***/ 85863:
/***/ ((module) => {

module.exports = "../../app/cells/components/lesson_player/faq_cell.rb";

/***/ }),

/***/ 86921:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 30741:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"root":"uzIkrRHjD4XikHkuXhW_"});

/***/ }),

/***/ 57873:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 82688:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 6211:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ LessonPlayer)
});

;// CONCATENATED MODULE: ./components/lesson_player/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/button_follow/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./utils/favorites_toggle/index.js
var favorites_toggle = __webpack_require__(48923);
// EXTERNAL MODULE: ./utils/event_manager/index.js
var event_manager = __webpack_require__(69705);
;// CONCATENATED MODULE: ./components/button_follow/index.js



(()=>{
    function favorite(resourceId) {
        const btn = document.querySelector(`.js-favorite[data-resource="${resourceId}"]`);
        if (btn.classList.contains('is-following')) {
            return;
        }
        btn.click();
    }
    event_manager/* EventManager.subscribe */.Q.subscribe('followOnComment', (_, resourceId)=>favorite(resourceId));
})();

// EXTERNAL MODULE: ./components/freemium/block_message/index.js
var block_message = __webpack_require__(68862);
// EXTERNAL MODULE: ./components/lesson_player/faq/index.erb
var faq = __webpack_require__(48848);
// EXTERNAL MODULE: ./components/lesson_player/faq/index.rb
var lesson_player_faq = __webpack_require__(85863);
// EXTERNAL MODULE: ./utils/trackers/zaraz.js
var zaraz = __webpack_require__(19394);
;// CONCATENATED MODULE: ./components/lesson_player/faq/index.js



(()=>{
    'use strict';
    const $container = window.jQuery('[data-event]');
    const eventData = $container.data('event') || {};
    if ($container && (eventData == null ? void 0 : eventData.active)) {
        zaraz/* default.set */.Z.set('show_experiment', 'true', {
            scope: 'persist'
        });
        zaraz/* default.track */.Z.track(eventData.event, eventData.event_props);
    }
})();

// EXTERNAL MODULE: ./components/video_player/index.js
var video_player = __webpack_require__(59097);
// EXTERNAL MODULE: ./styles/components/_responsive-embed.scss
var _responsive_embed = __webpack_require__(82688);
// EXTERNAL MODULE: ./utils/ajax_form/index.js
var ajax_form = __webpack_require__(13346);
;// CONCATENATED MODULE: ./components/feedback_form/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./utils/api_error_handler/index.js
var api_error_handler = __webpack_require__(98973);
;// CONCATENATED MODULE: ./components/feedback_form/index.js



class FeedbackForm {
    get config() {
        return this.$component.data();
    }
    swapAnswerFieldClasses(e) {
        const inputValue = e.currentTarget.value;
        this.reaction = this.getReaction(inputValue);
        const isLikeReaction = this.reaction === 'liked';
        this.$answerField.removeClass('q-answer--dislike q-answer--like');
        if (isLikeReaction) {
            !this.feedbackId && this.sendFeedback();
            this.$answerField.addClass('q-answer--like').show();
            return;
        }
        this.$answerField.addClass('q-answer--dislike').show();
    }
    bind() {
        this.$likeInputs.on('change', (e)=>{
            this.swapAnswerFieldClasses(e);
        });
        this.$component.ajaxForm(false).lazyReady().on('submit', (e)=>{
            e.preventDefault();
            this.sendFeedback();
            return false;
        });
        this.$cancelButton.on('click', ()=>{
            this.$likeInputs.prop('checked', false);
            this.$answerField.hide();
        });
    }
    getReaction(reaction) {
        const list = {
            1: 'liked',
            2: 'disliked'
        };
        return list[reaction];
    }
    setReactionButtonAsMarked(isLikeReaction) {
        const buttonSelector = isLikeReaction ? '.q-like' : '.q-dislike';
        const $buttonElement = window.jQuery(buttonSelector, this.$component).find('.q-icon');
        const { classToAdd, classToRemove } = $buttonElement.data();
        if (classToAdd && classToRemove) {
            $buttonElement.addClass(classToAdd);
            $buttonElement.removeClass(classToRemove);
        }
    }
    updateFeedback() {
        this.thorResource.update({
            id: this.feedbackId
        }, {
            data: this.feedbackContent
        }).then(()=>{
            this.handleFeedbackSuccess();
            this.$answerField.hide();
        }).catch(({ response })=>{
            this.handleError(response);
        });
    }
    setFeedbackData() {
        this.feedbackContent = this.$component.serializeObject();
        this.thorResource = Thor[this.config.resourceName];
    }
    handleError(err) {
        (0,api_error_handler/* handleApiError */.z)(null, err);
        this.$component.trigger('ajax:error');
        this.$likeButtons.attr('disabled', false);
    }
    handleFeedbackSuccess() {
        this.$component.clearForm().trigger('ajax:success').addClass('q-feedback-form--replied').data('replied', true);
        this.$likeInputs.remove();
        this.$likeButtons.attr({
            title: this.config.alreadyRepliedMessage,
            'data-toggle': 'tooltip',
            disabled: false
        });
        this.$likeButtons.removeAttr('for');
    }
    updateCounterValue() {
        const isLikeReaction = this.reaction === 'liked';
        const counterSelector = `.js-${isLikeReaction ? 'likes' : 'dislikes'}-count`;
        const $counter = window.jQuery(counterSelector, this.$component);
        const currentValue = parseInt($counter.html());
        this.setReactionButtonAsMarked(isLikeReaction);
        $counter.html(currentValue + 1);
    }
    sendFeedback() {
        this.setFeedbackData();
        if (!this.thorResource) {
            throw Error(`Model '${this.config.resourceName}' not found in Thor.`);
        }
        this.$likeButtons.attr('disabled', true);
        if (this.feedbackId) {
            return this.updateFeedback();
        }
        this.thorResource.create({}, {
            data: this.feedbackContent
        }).then((data)=>{
            this.feedbackId = data.id;
            this.handleFeedbackSuccess();
            this.updateCounterValue();
        }).catch(({ response })=>{
            this.handleError(response);
        });
    }
    constructor(context){
        const $element = window.jQuery('.js-feedback-form', window.jQuery(context));
        if (!$element.length) {
            return;
        }
        this.$component = window.jQuery($element.get(0));
        this.$likeButtons = window.jQuery('.q-likes-btn', this.$component);
        this.$likeInputs = window.jQuery(`[name="${this.config.resourceKey}[reaction]"]`, this.$component);
        this.$cancelButton = window.jQuery('.js-cancel-btn', this.$component);
        this.$answerField = window.jQuery('#js-answer-field', this.$component);
        this.bind();
    }
}
/* harmony default export */ const feedback_form = (FeedbackForm);

;// CONCATENATED MODULE: ./components/lesson_freemium/pre_text/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./utils/freemium/index.js
var freemium = __webpack_require__(68408);
;// CONCATENATED MODULE: ./components/lesson_freemium/pre_text/index.js


function runPreTextScript() {
    window.jQuery('.q-lesson-freemium-pre-text button').off('click').on('click', (event)=>{
        const $lesson = window.jQuery(event.currentTarget.closest('.q-track-text'));
        $lesson.addClass('lesson-opened');
        (0,freemium/* updateFreemiumCounter */.y)('lessons');
    });
}

;// CONCATENATED MODULE: ./components/lesson_player/notes/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./components/modals/basic_modal/index.js + 1 modules
var basic_modal = __webpack_require__(57039);
// EXTERNAL MODULE: ./utils/modal_manager/index.js
var modal_manager = __webpack_require__(87322);
;// CONCATENATED MODULE: ./components/lesson_player/notes/index.js





class LessonNotesTab {
    instantiateQuill() {
        const $editor = window.jQuery('#annotation-target', this.$context);
        if (!$editor.length || $editor.hasClass('ql-container')) return;
        this.editor = new Quill($editor.get(0), {
            modules: {
                toolbar: [
                    [
                        'bold',
                        'italic',
                        'underline'
                    ],
                    [
                        {
                            color: [
                                false,
                                'red',
                                'green',
                                'blue'
                            ]
                        }
                    ]
                ]
            },
            placeholder: 'Descreva a sua anotação...',
            theme: 'snow'
        });
        this.$lessonAnnotationArea = window.jQuery('.ql-editor', this.$context);
        this.fillQuillContent();
        this.collapseQuill();
    }
    fillQuillContent() {
        const $annotationValueElement = window.jQuery('.js-annotation-value', this.$context).val();
        if ($annotationValueElement !== '' && $annotationValueElement !== '<p> </p>') {
            this.$noteForm.addClass('q-lesson-player-annotation-edit');
        }
        this.$quillContent = window.jQuery('.ql-editor', this.$context);
        this.$quillContent.html($annotationValueElement);
    }
    bind() {
        const $createForm = window.jQuery('.js-create-note-form', this.$context);
        $createForm.ajaxForm(false).lazyReady().on('submit', (e)=>{
            e.preventDefault();
            if (this._validateAnnotationArea()) this.saveNote(e);
            return false;
        });
        window.jQuery('.js-edit-note-btn', this.$context).on('click', ()=>this.editNote());
        window.jQuery('.js-cancel-note-btn', this.$context).on('click', ()=>this.cancelNote());
        window.jQuery('.js-delete-note-btn', this.$context).on('click', (e)=>this.deleteNote(e));
        window.jQuery('.js-save-note-btn', this.$context).on('click', (e)=>this.newSaveNote(e));
    }
    saveNote(e) {
        this.$lessonAnnotationArea = window.jQuery('.ql-editor', this.$context).html();
        window.jQuery('.js-annotation-value').val(this.$lessonAnnotationArea);
        const $createForm = window.jQuery('.js-create-note-form', this.$context);
        const data = $createForm.serializeObject();
        const annotation_id = window.jQuery(e.currentTarget).data('annotation-id');
        const method = typeof annotation_id === 'undefined' ? 'create' : 'update';
        this.editor.enable(false);
        Thor.LessonAnnotation[method](annotation_id ? {
            id: annotation_id
        } : {}, {
            data: data
        }).then((annotation)=>{
            $createForm.trigger('ajax:success');
            if (method === 'create') this.bindNewId(annotation.id);
        }).catch(({ response })=>$createForm.trigger('ajax:error', response));
    }
    newSaveNote(e) {
        this.saveNote(e);
        this.$noteForm.removeClass('q-lesson-player-annotation-save');
        this.$noteForm.addClass('q-lesson-player-annotation-edit');
        this.$annotationBtn.removeClass('q-lesson-player-annotation-btn-save');
        this.editor.enable(false);
    }
    editNote() {
        this.$noteForm.removeClass('q-lesson-player-annotation-edit');
        this.$noteForm.addClass('q-lesson-player-annotation-save');
        this.$annotationBtn.addClass('q-lesson-player-annotation-btn-save');
        this.editor.enable(true);
    }
    cancelNote() {
        const $annotationValueElement = window.jQuery('.js-annotation-value', this.$context).val();
        this.$noteForm.addClass('q-lesson-player-annotation-edit');
        this.$noteForm.removeClass('q-lesson-player-annotation-save');
        this.$annotationBtn.removeClass('q-lesson-player-annotation-btn-save');
        this.$quillContent.html($annotationValueElement);
        this.editor.enable(false);
    }
    deleteNote(e) {
        modal_manager/* default.open */.Z.open('#js-confirm-delete-note-modal', (res)=>{
            if (!res) return;
            const annotationId = window.jQuery(e.currentTarget).data('annotation-id');
            Thor.LessonAnnotation.delete({
                id: annotationId
            }, {}).then(()=>{
                toastr.success('Anotação excluída com sucesso!');
                this.$noteForm.removeClass('q-lesson-player-annotation-edit');
                this.editor.setText('');
                this.editor.enable(true);
            }).catch(({ response })=>{
                (0,api_error_handler/* handleApiError */.z)('Ops! Não foi possível excluir sua anotação nesse momento!', response);
            });
        });
    }
    _validateAnnotationArea() {
        const hasBlankClass = window.jQuery('.ql-editor', this.$context).hasClass('ql-blank');
        const isWhiteSpace = this.$quillContent.html() === '';
        if (!hasBlankClass && !isWhiteSpace) {
            this.$noteForm.addClass('q-lesson-player-annotation-edit');
            return true;
        } else {
            toastr.warning('Seu comentário não pode ser vazio.');
            return false;
        }
    }
    collapseQuill() {
        const $quillContext = window.jQuery('.q-lesson-player-notes-quill', this.$context);
        const $icon = window.jQuery('.q-icon', $quillContext);
        const $collapseButton = window.jQuery('.collapse', $quillContext);
        $collapseButton.on('show.bs.collapse', ()=>{
            $icon.removeClass('q-icon-angle-down');
            $icon.addClass('q-icon-angle-up');
        });
        $collapseButton.on('hidden.bs.collapse', ()=>{
            $icon.removeClass('q-icon-angle-up');
            $icon.addClass('q-icon-angle-down');
        });
    }
    bindNewId(id) {
        window.jQuery('.js-delete-note-btn', this.$context).data('annotation-id', id);
        window.jQuery('.js-save-note-btn', this.$context).data('annotation-id', id);
    }
    constructor($context){
        vendorManager.ensure('quill', ()=>{
            this.$context = $context;
            this.$lessonAnnotationArea = false;
            this.$noteForm = window.jQuery('.js-create-note-form', this.$context);
            this.$annotationBtn = window.jQuery('.q-annotation-action-btn', this.$context);
            this.instantiateQuill();
            this.bind();
        });
    }
}


;// CONCATENATED MODULE: ./components/lesson_player/index.js








// eslint-disable-next-line import/extensions


class LessonPlayer {
    static start(context) {
        LessonPlayer._bind(context);
        new feedback_form(context);
        new LessonNotesTab(context);
        if (gon.flags.freemium_lessons) {
            runPreTextScript();
        }
    }
    static _bind(context) {
        window.jQuery('.js-lesson-progress', context).on('click', (event)=>{
            const $target = window.jQuery(event.currentTarget);
            const lessonId = $target.data('lesson-id');
            const hasStudied = $target.data('studied');
            const finishedTime = hasStudied ? '' : new Date();
            Thor.UserLessonProgress.update({
                lesson_id: lessonId
            }, {
                data: {
                    progress: {
                        finished_studying_at: finishedTime
                    }
                }
            }).then(()=>{
                $target.data('studied', !hasStudied);
                $target.toggleClass('q-watched');
                $target.find('.q-icon').toggleClass('q-icon-check-circle-solid');
                $target.find('.q-icon').toggleClass('q-icon-check-circle');
                $target.find('.q-lesson-progress-btn').text(!hasStudied ? 'Aula assistida' : 'Marcar como assistida');
                if (!hasStudied) {
                    toastr.success('Marcação realizada com sucesso');
                } else {
                    toastr.info('A aula agora está como não assistida.');
                }
            }).catch(({ response })=>{
                (0,api_error_handler/* handleApiError */.z)('Ops! Não foi possível marcar essa aula como estudada nesse momento!', response);
            });
        });
    }
}



/***/ }),

/***/ 57039:
/***/ (() => {

"use strict";

;// CONCATENATED MODULE: ./components/modals/basic_modal/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/modals/basic_modal/index.js



/***/ }),

/***/ 59097:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var utils_event_manager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69705);
/* harmony import */ var utils_freemium__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68408);


(function() {
    'use strict';
    function pauseVideo(element) {
        try {
            if (typeof element.pause === 'function') {
                element.pause();
            }
        } catch (ex) {
            Rollbar.error('Pause function not found or supported', ex);
        }
    }
    // function to pause all videos
    function pauseCloudflareVideos(current) {
        const selector = 'stream.js-video-player';
        const $current = window.jQuery(current);
        if (!$current.is(selector)) {
            return;
        }
        window.jQuery(selector).not($current).each((i, el)=>pauseVideo(el));
    }
    function emitEvent(current) {
        const $current = window.jQuery(current);
        const { eventEmitted, disciplineName, resourceType } = $current.data();
        if (eventEmitted) {
            return;
        }
        UserTracker.emit('event', {
            eventName: 'lesson played',
            data: {
                discipline: disciplineName
            }
        });
        $current.data('eventEmitted', true);
        if (gon.flags.freemium_lessons && resourceType === 'lessons') {
            const $lesson = $current.closest('.q-track-video');
            $lesson.addClass('lesson-opened');
            (0,utils_freemium__WEBPACK_IMPORTED_MODULE_1__/* .updateFreemiumCounter */ .y)('lessons');
        }
        if (resourceType === 'question_teacher') {
            const $teacher = $current.closest('.q-question-teacher');
            $teacher.addClass('teacher-opened');
            (0,utils_freemium__WEBPACK_IMPORTED_MODULE_1__/* .updateFreemiumCounter */ .y)('teachers');
        }
    }
    function handleRateChange() {
        const videoPlaybackRate = this.playbackRate || 1;
        if (localStorage) {
            localStorage.setItem('videoPlaybackRate', videoPlaybackRate);
        }
    }
    function setPlaybackSpeedRate(current) {
        if (localStorage) {
            const localStorageSpeedRate = Number(localStorage.getItem('videoPlaybackRate'));
            if (localStorageSpeedRate) {
                current.playbackRate = localStorageSpeedRate;
            }
        }
    }
    function setupLocalStorageConfig(current) {
        setPlaybackSpeedRate(current);
    }
    function handleVideoPlay() {
        const currentVideo = this;
        pauseCloudflareVideos(currentVideo);
        emitEvent(currentVideo);
        setupLocalStorageConfig(currentVideo);
    }
    function bindVideoEvents() {
        window.jQuery('.js-video-player').on('ratechange', handleRateChange);
        window.jQuery('.js-video-player').on('play', handleVideoPlay);
    }
    function bind() {
        window.jQuery(document).off('hide.bs.collapse.video-player').on('hide.bs.collapse.video-player', '.collapse', function() {
            window.jQuery('stream.js-video-player', this).each((i, el)=>pauseVideo(el));
        });
        // Pause videos when Question Belt Tab closes
        // eslint-disable-next-line no-undef
        utils_event_manager__WEBPACK_IMPORTED_MODULE_0__/* .EventManager.subscribe */ .Q.subscribe('questionBelt.tabClosed', (e, data)=>{
            window.jQuery('stream.js-video-player', data.$tabPane).each((i, el)=>pauseVideo(el));
        });
        const hasVideoPlayer = window.jQuery('.js-video-player').length;
        if (hasVideoPlayer) {
            return bindVideoEvents();
        }
        utils_event_manager__WEBPACK_IMPORTED_MODULE_0__/* .EventManager.subscribe */ .Q.subscribe('questionBelt.tabLoaded', ()=>{
            bindVideoEvents();
        });
    }
    bind();
})();


/***/ }),

/***/ 13346:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var utils_serialize_object__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49539);
/* harmony import */ var utils_serialize_object__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(utils_serialize_object__WEBPACK_IMPORTED_MODULE_0__);
//

(function($) {
    'use strict';
    class AjaxForm {
        onSuccess() {
            if (this.successMessage) toastr.success(this.successMessage);
            if (this.options.clearOnSuccess) this.$form.clearForm(this.options.clearHidden);
        }
        onError() {
            if (this.errorMessage) toastr.error(this.errorMessage);
        }
        constructor($form, options){
            this.$form = $form;
            this.successMessage = $form.data().successMessage;
            this.errorMessage = $form.data().errorMessage;
            this.options = options;
            this.$form.on('ajax:success', this.onSuccess.bind(this));
            this.$form.on('ajax:error', this.onError.bind(this));
        }
    }
    // jQuery Plugin
    if (!$.fn.ajaxForm) {
        $.fn.ajaxForm = function(clearOnSuccess = true, clearHidden = false) {
            const $form = $(this);
            if (!$form.is('form') || $form.get(0).ajaxForm) return $form;
            $form.get(0).ajaxForm = new AjaxForm($form, {
                clearOnSuccess: clearOnSuccess,
                clearHidden: clearHidden
            });
            return $form;
        };
    }
})(window.jQuery);


/***/ }),

/***/ 98973:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": () => (/* binding */ handleApiError)
/* harmony export */ });
/* harmony import */ var utils_session_expired__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29483);

function handleApiError(message, error) {
    if ((error == null ? void 0 : error.status) === 401) {
        utils_session_expired__WEBPACK_IMPORTED_MODULE_0__/* ["default"].renewSessionModal */ .Z.renewSessionModal(location.href);
    } else {
        toastr.error(message || 'Ocorreu um erro, tente novamente.');
        if (!(error == null ? void 0 : error.errors)) {
            return Rollbar.error(message, error);
        }
        const errors = Object.keys(error.errors);
        if (errors.length) {
            const errorKey = errors[0];
            const errorMsgs = error.errors[errorKey];
            const errorMsg = errorMsgs.length && errorMsgs[0] || '';
            Rollbar.error(`API response error${errorMsg && `: ${errorKey} ${errorMsg}`}.`, {
                status: error.status,
                statusText: error.statusText,
                responseText: error.responseText
            });
        }
    }
}


/***/ }),

/***/ 48923:
/***/ (() => {

(function($) {
    'use strict';
    const feedbackRequestComment = (success)=>{
        const $iconRequestComment = $('.js-icon-request-comment');
        const $titleRequestComment = $('.js-title-request-comment');
        const $textRequestComment = $('.js-text-request-comment');
        const $btnRequestComment = $('.js-button-request-comment');
        if (success) {
            $iconRequestComment.addClass('success').find('i').removeClass('q-icon-inbox').addClass('q-icon-check-circle');
            $titleRequestComment.html('Pedido realizado!');
            $textRequestComment.html('Quando um concurseiro comentar nesta questão, você será notificado por e-mail.');
            $btnRequestComment.html('Pedido realizado').attr('disabled', true);
            // tracking
            UserTracker.emit('event', {
                eventName: 'student commentary requested'
            });
        } else {
            $iconRequestComment.removeClass('success').find('i').removeClass('q-icon-check-circle').addClass('q-icon-inbox');
            $titleRequestComment.html('Precisa de ajuda?');
            $textRequestComment.html('Vamos buscar outros concurseiros para te auxiliar e comentar nesta questão. Você receberá um aviso por e-mail quando um novo comentário for feito.');
            $btnRequestComment.html('Pedir Comentário').attr('disabled', false);
        }
    };
    const emitToastr = ({ type, text, link = false })=>{
        const message = link ? text + link : text;
        return toastr[type](message);
    };
    const removeFavorite = (segment_id, resource_id, product, $button)=>{
        Thor.Favorite.delete({}, {
            qs: {
                segment_id,
                resource_id
            },
            data: {
                product
            }
        }).then(()=>{
            const { toFollowText } = $button.data();
            $button.find('.js-favorite-text').html(toFollowText);
            $button.removeClass('is-following').attr('disabled', false).blur();
            feedbackRequestComment(false);
            emitToastr({
                type: 'info',
                text: 'Atualização dos comentários da questão desativada'
            });
        });
    };
    const addFavorite = (segment_id, resource_id, product, $button)=>{
        Thor.Favorite.create({}, {
            data: {
                favorite: {
                    segment_id,
                    resource_id
                },
                product
            }
        }).then(()=>{
            const { followingText } = $button.data();
            $button.find('.js-favorite-text').html(followingText);
            $button.addClass('is-following').attr('disabled', false).blur();
            feedbackRequestComment(true);
            emitToastr({
                type: 'success',
                text: 'Acompanhando comentários da questão',
                link: gon.favorites_url && `<div><a href="${gon.favorites_url}"><strong>Acessar</strong></a></div>`
            });
        });
    };
    // Prevent to double bind our favorite button :D
    $(document).off('click.favorite', '.js-favorite').on('click.favorite', '.js-favorite', (event)=>{
        event.preventDefault();
        event.stopPropagation();
        const $button = $(event.currentTarget);
        const { segment, resource, product } = $button.data();
        const isFavorite = $button.hasClass('is-following');
        $button.attr('disabled', true);
        if (isFavorite) {
            removeFavorite(segment, resource, product, $button);
        } else {
            addFavorite(segment, resource, product, $button);
        }
    });
})(window.jQuery);


/***/ }),

/***/ 68408:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": () => (/* binding */ updateFreemiumCounter)
/* harmony export */ });
/* harmony import */ var utils_study_study__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21189);

const hideLessons = (resource, hideCurrent = false)=>{
    const resourceMap = {
        lessons: {
            elements: '.q-track-text, .q-track-video',
            currentElement: '.lesson-opened'
        },
        teachers: {
            elements: '.q-question-teacher',
            currentElement: '.teacher-opened'
        }
    };
    window.jQuery(resourceMap[resource].elements).not(hideCurrent ? null : resourceMap[resource].currentElement).each((_, item)=>{
        // Hide awareness banner
        window.jQuery(item).prev().remove();
        // Show freemium block message
        window.jQuery(item).next().show();
        // Remove item content
        window.jQuery(item).remove();
    });
};
function updateFreemiumCounter(resource) {
    utils_study_study__WEBPACK_IMPORTED_MODULE_0__/* ["default"].track */ .Z.track(resource, (response)=>{
        if (response[`${resource}_limit_reached`]) {
            hideLessons(resource);
        }
    }, (error)=>{
        if (error.response.status === 422 || currentUser.subscriptionStatus === 'standard') {
            hideLessons(resource, true);
        }
    });
}


/***/ }),

/***/ 40225:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": () => (/* binding */ Controller),
/* harmony export */   "M": () => (/* binding */ Application)
/* harmony export */ });
/* harmony import */ var stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56938);
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82941);
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pubsub_js__WEBPACK_IMPORTED_MODULE_1__);


// Adding trigger and on to controllers
(pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().immediateExceptions) = RAILS_ENV === 'development';
class Controller extends stimulus__WEBPACK_IMPORTED_MODULE_0__/* .Controller */ .Qr {
    trigger(identifier, params) {
        const parts = identifier.split('->');
        if (parts.length < 2) throw new Error('Event identifier is in an incorrect format!');
        const controller = parts[0];
        const action = parts[1];
        pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().publish(`stimulus.${controller}.${action}`, params);
    }
    on(action, callback) {
        const controller = this.identifier;
        pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().subscribe(`stimulus.${controller}.${action}`, (eventName, params)=>callback(params));
    }
    disconnect() {
        const controller = this.identifier;
        pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().unsubscribe(`stimulus.${controller}`);
        return super.disconnect();
    }
    constructor(){
        super(...arguments);
    }
}
class Application extends stimulus__WEBPACK_IMPORTED_MODULE_0__/* .Application */ .Mx {
    register(identifier, controllerConstructor) {
        if (this.controllers.indexOf(controllerConstructor) === -1) return super.register(identifier, controllerConstructor);
        else console.warning(`Controller "${identifier}" already registered!`);
    }
    constructor(){
        super(...arguments);
    }
}



/***/ }),

/***/ 21189:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ Study)
});

// EXTERNAL MODULE: ./components/welcome_checklist/index.scss
var welcome_checklist = __webpack_require__(57873);
// EXTERNAL MODULE: ./utils/cookie_manager/index.js
var cookie_manager = __webpack_require__(88526);
// EXTERNAL MODULE: ./utils/stimulus/index.js
var stimulus = __webpack_require__(40225);
;// CONCATENATED MODULE: ./components/welcome_checklist/index.js



const localStorageKey = `welcomeChecklist.${currentUser.id}`;
const questionPageUrl = '/questoes-de-concursos/questoes?has_commentaries=true&has_professor_commentaries=true';
const getInitialChecklist = ()=>{
    return JSON.parse(window.localStorage.getItem(localStorageKey)) || {
        lastUpdate: null,
        account: {
            title: 'Crie sua conta',
            subtitle: 'Cadastre-se e comece a sua jornada!',
            icon: 'check-circle-solid',
            completed: true,
            link: '#'
        },
        valhalla: {
            title: 'Conheça as Apostilas Digitais',
            subtitle: 'Estude com material em PDF + Aulas',
            icon: 'book',
            completed: false,
            link: '[ils]b/guia-de-estudos/busca/pdf'
        },
        lessons: {
            title: 'Assista a aula de um curso',
            subtitle: 'Conteúdo feito pelos melhores professores',
            icon: 'play-circle',
            completed: false,
            link: '[ils]meu-guia'
        },
        answers: {
            title: 'Responda Questões',
            subtitle: 'Aplique um filtro e comece sua prática!',
            icon: 'list-ul',
            completed: false,
            link: questionPageUrl
        },
        comments: {
            title: 'Veja comentários das questões',
            subtitle: 'Conheça nossa comunidade de alunos',
            icon: 'comments',
            completed: false,
            link: questionPageUrl
        },
        teachers: {
            title: 'Veja os Gabaritos dos professores',
            subtitle: 'Veja comentários dos professores',
            icon: 'graduation-cap',
            completed: false,
            link: questionPageUrl
        }
    };
};
const saveChecklist = (checklist)=>{
    checklist.lastUpdate = new Date().toDateString();
    window.localStorage.setItem(localStorageKey, JSON.stringify(checklist));
};
const notifyWelcomeChecklist = (resource)=>{
    if (!gon.flags.user_onboarding.active) {
        return;
    }
    const checklist = getInitialChecklist();
    if (checklist[resource].completed) {
        return;
    }
    checklist[resource].completed = true;
    saveChecklist(checklist);
};
class WelcomeChecklist extends stimulus/* Controller */.Q {
    connect() {
        this.getTasks();
        if (this.isOnboardingComplete()) {
            this.element.remove();
            return;
        }
        this.calculateTaskProgress();
        this.render();
    }
    getTasks() {
        const checklist = getInitialChecklist();
        const isIlsLessonComplete = cookie_manager/* default.getCookie */.Z.getCookie(`${localStorageKey}.lessons`) === 'true';
        const isIlsValhallaComplete = cookie_manager/* default.getCookie */.Z.getCookie(`${localStorageKey}.valhalla`) === 'true';
        if (!checklist.lessons.completed && isIlsLessonComplete) {
            checklist.lessons.completed = true;
            saveChecklist(checklist);
        }
        if (!checklist.valhalla.completed && isIlsValhallaComplete) {
            checklist.valhalla.completed = true;
            saveChecklist(checklist);
        }
        this.tasks = [
            checklist.account,
            checklist.valhalla,
            checklist.lessons,
            checklist.answers,
            checklist.comments,
            checklist.teachers
        ];
        this.lastUpdate = checklist.lastUpdate;
    }
    isOnboardingComplete() {
        const isAllCompleted = this.tasks.every((task)=>task.completed);
        const isAnotherDay = new Date(this.lastUpdate).getDate() !== new Date().getDate();
        return isAllCompleted && isAnotherDay;
    }
    calculateTaskProgress() {
        this.numberOfStepDone = this.tasks.filter((task)=>task.completed).length;
        this.numberOfStepTotal = this.tasks.length;
    }
    render() {
        this.renderProgressBar();
        this.renderMessage();
        this.renderCompletedText();
        this.renderTasks();
    }
    renderProgressBar() {
        this.progressBarTarget.style.width = `${100 * this.numberOfStepDone / this.numberOfStepTotal}%`;
    }
    renderMessage() {
        if (this.numberOfStepDone === 1) {
            this.messageTarget.textContent = 'Dê seus primeiros passos!';
        } else {
            this.messageTarget.classList.add('information__message--inprogress');
            this.messageTarget.textContent = this.numberOfStepDone === this.numberOfStepTotal ? 'Boa, sua jornada começou! Continue estudando!' : 'Você está mandando bem!';
        }
    }
    renderCompletedText() {
        this.completedTextTarget.textContent = `${this.numberOfStepDone}/${this.numberOfStepTotal} CONCLUÍDOS`;
    }
    renderTasks() {
        this.tasksContainerTarget.innerHTML = this.tasks.map((task)=>`
        <a href="${this.parseLink(task.link)}" class="tasks__item
          ${task.completed ? 'tasks__item--completed' : ''}
          ${task.link === '#' ? 'tasks__item--nolink' : ''}
        ">
          <div class="icon-container">
            <i class="q-icon q-icon-${task.completed ? 'check-circle-solid' : task.icon}"></i>
          </div>

          <div class="text-container">
            <p class="title">${task.title}</p>
            <p class="subtitle">${task.subtitle}</p>
          </div>
        </a>
        `).join('');
    }
    parseLink(link) {
        return link.includes('[ils]') ? link.replace('[ils]', this.element.getAttribute('data-ils-path')) : link;
    }
    constructor(...args){
        super(...args);
        this.tasks = [];
        this.lastUpdate = null;
        this.numberOfStepDone = 0;
        this.numberOfStepTotal = 0;
    }
}
WelcomeChecklist.targets = [
    'progressBar',
    'message',
    'completedText',
    'tasksContainer'
];

(self || window).WelcomeChecklistApplication = (self || window).WelcomeChecklistApplication || stimulus/* Application.start */.M.start();
(self || window).WelcomeChecklistApplication.register('welcome-checklist', WelcomeChecklist);

;// CONCATENATED MODULE: ./utils/study/study.js

class Study {
    static track(resourceType, successCallback = ()=>{}, errorCallback = ()=>{}) {
        Thor.Question.check_limits({
            id: currentUser.id
        }, {
            data: {
                component_name: resourceType
            }
        }).then((response)=>{
            successCallback(response);
            if (Study.resources.includes(resourceType)) {
                Study.notifyBenefitsFeatures();
                Study.updateWelcomeChecklist(resourceType);
            }
        }).catch((error)=>{
            if (error) {
                errorCallback(error);
            }
        });
    }
    static trackWithoutCheckLimits(resourceType) {
        if (!Study.resources.includes(resourceType)) {
            return;
        }
        Study.notifyBenefitsFeatures();
        Study.updateWelcomeChecklist(resourceType);
    }
    static notifyBenefitsFeatures() {
        if (window.callBenefitsWeeklyModal) {
            window.callBenefitsWeeklyModal();
        }
        if (window.updateBenefitsStudyDays) {
            window.updateBenefitsStudyDays();
        }
    }
    static updateWelcomeChecklist(resourceType) {
        let resource = resourceType;
        if (resource === 'question_comments') {
            resource = resource.replace('question_', '');
        }
        notifyWelcomeChecklist(resource);
    }
}
Study.resources = [
    'lessons',
    'teachers',
    'comments',
    'question_comments',
    'answers'
];



/***/ }),

/***/ 19394:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* eslint-disable no-console */ class Zaraz {
    static enqueue(method, args) {
        if (this.isScriptLoaded) {
            window.zaraz[method](...args);
        } else {
            if (window.RAILS_ENV === 'development') {
                console.log(`Zaraz (Dev): ${method}`, args);
            }
            this.queue.push([
                method,
                args
            ]);
        }
    }
    static ecommerce(event, payload) {
        this.enqueue('ecommerce', [
            event,
            payload
        ]);
    }
    static track(event, payload) {
        this.enqueue('track', [
            event,
            payload
        ]);
    }
    static set(prop, value, params = {}) {
        this.enqueue('set', [
            prop,
            value,
            params
        ]);
    }
    static setContentGroup() {
        window.zaraz.set('content_group', gon.current_path, {
            scope: 'page'
        });
    }
    static start() {
        const intervalId = setInterval(()=>{
            if (!window.zaraz) {
                return;
            }
            Zaraz.isScriptLoaded = true;
            clearInterval(intervalId);
            this.setContentGroup();
            document.addEventListener('turbolinks:load', ()=>{
                this.setContentGroup();
            });
            this.queue.forEach(([method, args])=>{
                window.zaraz[method](...args);
            });
        }, 1000);
    }
}
Zaraz.isScriptLoaded = false;
Zaraz.queue = [];
if (window.RAILS_ENV !== 'development') {
    Zaraz.start();
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Zaraz);


/***/ })

}]);